/* Stop the Klaviyo popup from swallowing every click on the page.
 *
 * Klaviyo's onsite embed renders its popup inside a FULL-VIEWPORT fixed container at
 * z-index 90000 with `pointer-events: auto`. About six seconds after load that container
 * sits on top of everything, and measured on the LIVE store it made the Add to Cart button
 * unclickable — not just the personalizer. A customer who does not notice the popup simply
 * finds that the button has stopped working.
 *
 * This does NOT hide or dismiss the popup: it keeps showing and stays fully usable, because
 * only the full-screen backdrop loses pointer events while its children keep them. The
 * signup still converts; the page underneath is no longer held hostage.
 *
 * The real fix is in Klaviyo itself — exclude product pages from the form's targeting, or
 * trigger on exit intent instead of a timer. That is a dashboard change, not an API one
 * (the Forms API exposes form metadata only). When it is done, delete this file.
 *
 * Deliberately measured rather than selector-matched: Klaviyo's class names carry a random
 * suffix (`kl-private-reset-css-Xuajs1`) and its DOM nests several such divs, so "the one
 * that covers the viewport" is the only stable description of the offender.
 */
(() => {
  const SEL = 'div[class*="kl-private-reset-css-"]';
  const MARK = 'pz-klaviyo-passthrough';

  const style = document.createElement('style');
  style.textContent = `
    ${SEL}.${MARK} { pointer-events: none !important; }
    ${SEL}.${MARK} > * { pointer-events: auto !important; }`;
  document.head.append(style);

  const sweep = () => {
    for (const el of document.querySelectorAll(SEL)) {
      const r = el.getBoundingClientRect();
      const covers = r.width > window.innerWidth * 0.9 && r.height > window.innerHeight * 0.9;
      // Re-evaluated every time: the popup can resize, and a container that stops covering
      // the viewport should get its click handling back.
      el.classList.toggle(MARK, covers && getComputedStyle(el).position === 'fixed');
    }
  };

  new MutationObserver(sweep).observe(document.documentElement,
    { childList: true, subtree: true });
  addEventListener('resize', sweep);
  // Klaviyo announces its own lifecycle; cheaper and more timely than polling.
  addEventListener('klaviyoForms', sweep);
  sweep();
})();
